<template>
  <div id="app" class="profitability-report-page">
    <yetkidialog ref="yetkidialog"></yetkidialog>
    <hatadialog ref="hatadialog"></hatadialog>

    <v-app id="inspire" light>
      <v-card color="grey lighten-5" flat class="page-card">
        <v-layout row wrap>
          <v-flex xs12 md12 sm12>
            <v-toolbar dark color="info" class="page-toolbar">
              <v-toolbar-title>{{ $t('Profitability-Report') }}</v-toolbar-title>
              <v-spacer></v-spacer>

              <v-menu bottom left offset-y>
                <v-btn slot="activator" dark icon>
                  <v-icon>more_vert</v-icon>
                </v-btn>

                <v-list class="menu-list">
                  <v-list-tile @click="getListDetayExcel()">
                    <v-list-tile-title>
                      {{ $t('Karlılık Raporu Detay Excel') }}
                    </v-list-tile-title>
                  </v-list-tile>

                  <v-list-tile @click="getListOzetExcel()">
                    <v-list-tile-title>
                      {{ $t('Profitability-Report-Summary-Excel') }}
                    </v-list-tile-title>
                  </v-list-tile>
                </v-list>
              </v-menu>
            </v-toolbar>
          </v-flex>

          <v-container fluid class="page-container">
            <v-form ref="formgunluksatis" v-model="valid" lazy-validation>
              <v-layout row wrap>
                <v-flex pb-3 xs12 sm12 md12>
                  <v-card flat class="filter-card">
                    <v-card-text class="pb-0">
                      <v-layout row wrap>
                        <v-flex xs12 sm6 pl-1 pt-2 md2>
                          <v-select
                            :label="$t('Date-Type')"
                            item-value="value"
                            item-text="text"
                            :items="itemstarihtip"
                            v-model="tarihTip"
                            solo
                            flat
                            hide-details
                          ></v-select>
                        </v-flex>

                        <v-flex xs12 sm6 pt-2 md2>
                          <tarihcomp
                            :etiket="$t('Starting-Date')"
                            :detaygizle="false"
                            :rules="dateRules"
                            :defaultvalue="'ok'"
                            :value="KayitTarihiBasla"
                            v-model="KayitTarihiBasla"
                          ></tarihcomp>
                        </v-flex>

                        <v-flex xs12 pt-2 sm6 md2>
                          <tarihcomp
                            :etiket="$t('Finishing-Date')"
                            :detaygizle="false"
                            :rules="dateRules"
                            :defaultvalue="'ok'"
                            :value="KayitTarihiBitis"
                            v-model="KayitTarihiBitis"
                          ></tarihcomp>
                        </v-flex>

                        <v-flex xs12 pt-2 sm6 md2>
                          <v-select
                            hide-details
                            :items="doviztipi"
                            v-model="Rapor.PPNR_ParaBirimi"
                            :rules="[(v) => !!v || $t('Mandatory-section')]"
                            item-text="Title"
                            item-value="DovizKod"
                            :label="$t('Currency-Unit')"
                            solo
                            flat
                          ></v-select>
                        </v-flex>

                        <v-flex xs12 pt-2 sm6 md2>
                          <v-layout justify-center row full-width>
                            <v-radio-group row v-model="raporTipi" class="mt-0 pt-0">
                              <v-radio :label="$t('Detail-Report')" value="0"></v-radio>
                              <v-radio :label="$t('Summary-Report')" value="1"></v-radio>
                            </v-radio-group>
                          </v-layout>
                        </v-flex>

                        <v-flex xs12 pt-2 md2>
                          <div class="filter-actions">
                            <div v-if="load1">
                              <v-btn color="info" @click="getList()" fab small dark>
                                <v-icon>search</v-icon>
                              </v-btn>
                            </div>

                            <div v-if="progress" class="progress-wrap">
                              <v-progress-circular
                                indeterminate
                                :width="4"
                                color="blue"
                                size="28"
                              ></v-progress-circular>
                            </div>

                            <v-tooltip bottom>
                              <v-btn
                                slot="activator"
                                small
                                @click="filtrele()"
                                color="info"
                                fab
                                dark
                              >
                                <v-icon>filter_list</v-icon>
                              </v-btn>
                              <span>{{ $t('Add-Search-Filter') }}</span>
                            </v-tooltip>

                            <v-chip
                              v-if="filtrevarmi"
                              small
                              color="green"
                              text-color="white"
                              class="filter-chip"
                            >
                              <v-icon left small>check_circle_outline</v-icon>
                              {{ $t('Filter') }}
                            </v-chip>
                          </div>
                        </v-flex>
                      </v-layout>
                    </v-card-text>
                  </v-card>
                </v-flex>

                <v-flex xs12 sm12 md12 pb-3>
                  <ReportTable
                    :headers="activeHeaders"
                    :items="activeItems"
                    :loading="progress"
                    :has-searched="hasSearched"
                    :storage-key="activeStorageKey"
                    :search-label="$t('Search')"
                    :show-frontend-export="true"
                    :rows-per-page-items="[20, 100]"
                    class="report-table-host"
                  >
                    <template slot="cell" slot-scope="slotProps">
                      {{ slotProps.value }}
                    </template>
                  </ReportTable>
                </v-flex>
              </v-layout>
            </v-form>
          </v-container>

          <v-snackbar
            :timeout="timeout"
            :top="y === 'top'"
            :bottom="y === 'bottom'"
            :right="x === 'right'"
            :left="x === 'left'"
            :multi-line="mode === 'multi-line'"
            :vertical="mode === 'vertical'"
            v-model="snackbar"
          >
            {{ text1 }}
            <v-btn flat color="pink" @click="snackbar = false">
              {{ $t('Close') }}
            </v-btn>
          </v-snackbar>

          <v-dialog
            v-model="dialogfiltre"
            scrollable
            persistent
            max-width="400px"
          >
            <v-card flat color="grey lighten-4">
              <v-card-title>{{ $t('Filter-selection') }}</v-card-title>
              <v-divider></v-divider>
              <v-card-text>
                <v-layout row wrap>
                  <v-flex xs12 sm6 md12 pa-1>
                    <v-card flat class="white--text">
                      <v-card flat color="grey lighten-5">
                        <v-card-actions>
                          <v-layout row wrap>
                            <v-flex md12 xs12 sm12>
                              <pnrbul v-model="Rapor.PPNR_No" hide-details></pnrbul>
                            </v-flex>

                            <v-flex md12 xs12 sm12>
                              <cariaracomp
                                :etiket="$t('Currentcode_label')"
                                :value="Rapor.PCariKod"
                                v-model="Rapor.PCariKod"
                                :Coper="true"
                              ></cariaracomp>
                            </v-flex>

                            <v-flex md6 xs12 sm6>
                              <v-select
                                clearable
                                :items="itemssaticitip"
                                item-text="Aciklama"
                                item-value="Kod"
                                v-model="Rapor.PSaticiTip"
                                :label="$t('Seller-Type')"
                                hide-details
                              >
                              </v-select>
                            </v-flex>

                            <v-flex xs12 sm6 md6>
                              <genelarama
                                :autofocuss="true"
                                apiname="SaticiAra"
                                :tip="Rapor.PSaticiTip"
                                :label="$t('Seller-Code')"
                                v-model="Rapor.PSaticiKod"
                              ></genelarama>
                            </v-flex>

                            <v-flex xs12 sm12 md12>
                              <v-text-field
                                hide-details
                                v-model="Rapor.PCariHesapGrubu"
                                :label="$t('Account-Group')"
                              >
                              </v-text-field>
                            </v-flex>

                            <v-flex xs12 sm12 md6>
                              <v-text-field
                                hide-details
                                v-model="Rapor.PCariTip"
                                :label="$t('Current-Account-Type')"
                              >
                              </v-text-field>
                            </v-flex>

                            <v-flex xs12 sm12 md6>
                              <v-text-field
                                hide-details
                                v-model="Rapor.PSaticiGrup"
                                :label="$t('Seller-Group')"
                              >
                              </v-text-field>
                            </v-flex>

                            <v-flex md12 xs12 sm12>
                              <v-select
                                :items="itemsicdis"
                                item-text="text"
                                item-value="value"
                                v-model="Rapor.PSaticiIc_Dis"
                                label="İç Dış"
                                hide-details
                              >
                              </v-select>
                            </v-flex>

                            <v-flex xs12 sm12 md12>
                              <genelarama
                                apiname="SaticiAra"
                                :tip="12"
                                :label="$t('Tour-Operator')"
                                v-model="Rapor.PTurOp"
                              >
                              </genelarama>
                            </v-flex>

                            <v-flex xs12 sm12 md12>
                              <genelarama
                                apiname="SaticiAra"
                                :tip="4"
                                :label="$t('Agency')"
                                v-model="Rapor.PAcente"
                              >
                              </genelarama>
                            </v-flex>

                            <v-flex xs12 sm12 md12>
                              <v-select
                                hide-details
                                :items="itemsfaturali"
                                v-model="Rapor.PFaturali"
                                item-text="text"
                                item-value="value"
                                :label="$t('Sales-Invoice')"
                              ></v-select>
                            </v-flex>

                            <v-flex md12 xs12 sm12>
                              <v-select
                                :items="itemsopsiyon"
                                item-text="text"
                                item-value="value"
                                v-model="Rapor.POpsiyon"
                                :label="$t('Optional-Sales')"
                                hide-details
                              >
                              </v-select>
                            </v-flex>

                            <v-flex md12 xs12 sm12>
                              <anatip v-model="Rapor.PAnaTip"></anatip>
                            </v-flex>

                            <v-flex md12 xs12 sm12>
                              <cariaracomp
                                :etiket="$t('Current-Main-Account')"
                                :value="Rapor.PCariAnaHesap"
                                v-model="Rapor.PCariAnaHesap"
                                :Coper="true"
                              ></cariaracomp>
                            </v-flex>

                            <v-flex pl-1 xs12 sm12 md12>
                              <genelarama
                                apiname="MasrafMerkeziAra"
                                :label="$t('Expense-Center-v2')"
                                v-model="Rapor.PMasrafMerkezi"
                              ></genelarama>
                            </v-flex>

                            <v-flex md12 xs12 sm12>
                              <geneltipara
                                v-model="Rapor.PAcenteDepartmanID"
                                tip="AcenteDepartman"
                              >
                              </geneltipara>
                            </v-flex>

                            <v-flex xs12 sm12 md12>
                              <v-select
                                hide-details
                                :items="itemskomisyon"
                                v-model="Rapor.PKomisyonFaturali"
                                item-text="text"
                                item-value="value"
                                :label="$t('Commission-Invoice')"
                              ></v-select>
                            </v-flex>

                            <v-flex md12 xs12 sm12>
                              <v-checkbox
                                hide-details
                                :label="$t('Except-Receipt')"
                                v-model="Rapor.PDekontHaric"
                              ></v-checkbox>
                            </v-flex>

                            <v-flex md12 xs12 sm12>
                              <v-checkbox
                                hide-details
                                :label="$t('To-be-paid-to-the-hotel-the-guest')"
                                v-model="Rapor.PSatisTip1"
                              >
                              </v-checkbox>
                            </v-flex>

                            <v-flex md12 xs12 sm12>
                              <v-checkbox
                                hide-details
                                :label="$t('By-our-Agency-excluding-extras')"
                                v-model="Rapor.PSatisTip2"
                              >
                              </v-checkbox>
                            </v-flex>

                            <v-flex md12 xs12 sm12>
                              <v-checkbox
                                hide-details
                                :label="$t('Full-Credit-by-our-Agency')"
                                v-model="Rapor.PSatisTip3"
                              >
                              </v-checkbox>
                            </v-flex>

                            <v-flex md12 xs12 sm12>
                              <v-checkbox
                                hide-details
                                :label="$t('By-Tour-Operator')"
                                v-model="Rapor.PSatisTip4"
                              >
                              </v-checkbox>
                            </v-flex>

                            <v-flex xs12 sm12 md12>
                              <v-layout justify-space-between column>
                                <v-checkbox
                                  v-model="tumsirketler"
                                  :label="$t('All-Companies')"
                                  hide-details
                                ></v-checkbox>
                              </v-layout>
                            </v-flex>
                          </v-layout>
                        </v-card-actions>
                      </v-card>
                    </v-card>
                  </v-flex>
                </v-layout>
              </v-card-text>

              <v-divider></v-divider>

              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" flat @click="filtreiptal()">
                  {{ $t('cancel_button') }}
                </v-btn>
                <v-btn color="blue darken-1" flat @click="filtrekayit()">
                  {{ $t('Apply-Filters') }}
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>

          <v-dialog v-if="iptalDialog" v-model="iptalDialog" max-width="450px">
            <v-card>
              <v-card-text>
                <v-container>
                  <v-form ref="formiptal" v-model="valid" lazy-validation>
                    <v-layout class="project overdue" row wrap>
                      <v-flex xs12 pb-2 sm12 md12>
                        <v-layout row wrap>
                          <v-toolbar flat size="120px" dark color="white">
                            <v-toolbar-title>
                              <span class="subheading black--text">
                                {{ $t('Details-of-PNR-Cancelled') }}
                              </span>
                            </v-toolbar-title>
                            <v-spacer></v-spacer>
                          </v-toolbar>
                        </v-layout>
                      </v-flex>

                      <v-flex pl-4 xs3 md3 sm3>
                        <span>{{ $t('PNR-No') }}</span>
                      </v-flex>
                      <v-flex xs9 md9 sm9>
                        <span>:{{ secilenKayit.PNR_No }}</span>
                      </v-flex>
                      <v-flex xs3 pl-4 md3 sm3>
                        <span>Cari</span>
                      </v-flex>
                      <v-flex xs9 md9 sm9>
                        <span>:{{ secilenKayit.CariKod }}-{{ secilenKayit.Unvan }}</span>
                      </v-flex>
                    </v-layout>

                    <v-flex pl-4 pt-2 xs12 md12 sm12>
                      <v-text-field
                        hide-details
                        :rules="[(v) => !!v || $t('Mandatory-Areas')]"
                        v-model="IptalNedeni"
                        :label="$t('Reason-of-Cancellation')"
                      ></v-text-field>
                    </v-flex>
                  </v-form>
                </v-container>
              </v-card-text>

              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="info" flat @click="iptalDialog = false">
                  {{ $t('cancel_button') }}
                </v-btn>
                <v-btn color="info" flat @click="pnrIptal()">
                  {{ $t('OK') }}
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-layout>
      </v-card>
    </v-app>
  </div>
</template>

<script>
import auth from "../../../../api/auth";
import tarihcomp from "../../customcomp/tarihim";
import helpers from "@/components/app/customcomp/helpers.js";
import yetkidialog from "@/components/app/customcomp/yetkidialog.vue";
import tool from "../../coper/tools";
import hatadialog from "@/components/app/coper/comp/hatadialog.vue";
import pnrbul from "@/components/app/coper/component/pnrbul.vue";
import genelarama from "@/components/app/coper/comp/genelarama.vue";
import anatip from "@/components/app/coper/comp/anatip.vue";
import rez from "../rezervasyon";
import geneltipara from "@/components/app/coper/comp/geneltipara.vue";
import cariaracomp from "@/components/app/customcomp/cariaracomp.vue";
import ReportTable from "@/components/app/customcomp/ReportTable.vue";

function createDetailHeaders(vm) {
  return [
    { text: vm.$t("Company-No"), value: "SirketNo", type: "text", align: "center", visible: true, sortable: true, minWidth: "120px" },
    { text: vm.$t("PNR-No"), value: "PNR_No", type: "text", align: "left", visible: true, sortable: true, minWidth: "130px" },
    { text: vm.$t("Current-Title"), value: "CariUnvan", type: "text", align: "left", visible: true, sortable: true, minWidth: "220px" },
    { text: vm.$t("Seller"), value: "SaticiAd", type: "text", align: "left", visible: true, sortable: true, minWidth: "180px" },
    { text: vm.$t("Name"), value: "Isim", type: "text", align: "left", visible: true, sortable: true, minWidth: "180px" },
    { text: vm.$t("Night"), value: "Gece", type: "text", align: "center", visible: true, sortable: true, minWidth: "100px" },
    { text: vm.$t("SalesFN"), value: "SatisFaturaNo", type: "text", align: "right", visible: true, sortable: true, minWidth: "150px" },
    { text: vm.$t("SalesFT"), value: "SatisFaturaTarih", type: "text", align: "right", visible: true, sortable: true, minWidth: "150px" },
    { text: vm.$t("IncomingFN"), value: "GelenFaturaNo", type: "text", align: "right", visible: true, sortable: true, minWidth: "150px" },
    { text: vm.$t("IncomingFT"), value: "GelenFaturaTarih", type: "text", align: "right", visible: true, sortable: true, minWidth: "160px" },
    { text: vm.$t("RefundFN"), value: "IadeFaturaNo", type: "text", align: "right", visible: true, sortable: true, minWidth: "150px" },
    { text: vm.$t("RefundFT"), value: "IadeFaturaTarih", type: "text", align: "right", visible: true, sortable: true, minWidth: "150px" },
    { text: vm.$t("CommisionFN"), value: "KomFaturaNo", type: "text", align: "right", visible: true, sortable: true, minWidth: "150px" },
    { text: vm.$t("CommisionFT"), value: "KomFaturaTarih", type: "text", align: "right", visible: true, sortable: true, minWidth: "160px" },
    { text: vm.$t("Sales-Invoice-Amount"), value: "SatisFaturaTutar", type: "money", align: "right", visible: true, sortable: true, minWidth: "160px" },
    { text: vm.$t("İncoming-Invoice-Amount"), value: "GelenFaturaTutar", type: "money", align: "right", visible: true, sortable: true, minWidth: "170px" },
    { text: vm.$t("Refund-Invoice-Amount"), value: "IadeFaturaTutar", type: "money", align: "right", visible: true, sortable: true, minWidth: "170px" },
    { text: vm.$t("Commision-Invoice-Amount"), value: "KomFaturaTutar", type: "money", align: "right", visible: true, sortable: true, minWidth: "180px" },
    { text: vm.$t("Profit-with-Vat"), value: "Kar_KDV_li", type: "money", align: "right", visible: true, sortable: true, minWidth: "150px" },
    { text: vm.$t("Profit-Percent-VAT"), value: "Kar_Yuzde_KDV_li", type: "money", align: "right", visible: true, sortable: true, minWidth: "160px" }
  ];
}

function createSummaryHeaders(vm) {
  return [
    { text: vm.$t("Company-No"), value: "SirketNo", type: "text", align: "center", visible: true, sortable: true, minWidth: "120px" },
    { text: vm.$t("Title"), value: "CariUnvan", type: "text", align: "left", visible: true, sortable: true, minWidth: "220px" },
    { text: vm.$t("Night"), value: "Gece", type: "text", align: "center", visible: true, sortable: true, minWidth: "100px" },
    { text: vm.$t("Sales-Invoice-Amount"), value: "SatisFaturaTutar", type: "money", align: "right", visible: true, sortable: true, minWidth: "160px" },
    { text: vm.$t("İncoming-Invoice-Amount"), value: "GelenFaturaTutar", type: "money", align: "right", visible: true, sortable: true, minWidth: "170px" },
    { text: vm.$t("Refund-Invoice-Amount"), value: "IadeFaturaTutar", type: "money", align: "right", visible: true, sortable: true, minWidth: "170px" },
    { text: vm.$t("Commision-Invoice-Amount"), value: "KomFaturaTutar", type: "money", align: "right", visible: true, sortable: true, minWidth: "180px" },
    { text: vm.$t("Profit-with-Vat"), value: "Kar_KDV_li", type: "money", align: "right", visible: true, sortable: true, minWidth: "150px" },
    { text: vm.$t("Profit-Percent-VAT"), value: "Kar_Yuzde_KDV_li", type: "money", align: "right", visible: true, sortable: true, minWidth: "160px" }
  ];
}

function beforeMount() {}

export default {
  name: "KarlilikRaporu",
  beforeMount,
  components: {
    tarihcomp,
    yetkidialog,
    hatadialog,
    pnrbul,
    anatip,
    genelarama,
    geneltipara,
    cariaracomp,
    ReportTable
  },
  filters: {
    dateformat(t) {
      return helpers.dateformat(t);
    },
    moneyformat(m) {
      return helpers.moneyformat(m);
    },
    bakiyekontrol(m) {
      return helpers.bakiyekontrol(m);
    }
  },
  data() {
    return {
      hasSearched: false,
      detailHeaders: [],
      summaryHeaders: [],
      tumsirketler: false,
      tarihTip: 0,
      date1: null,
      date2: null,
      KayitTarihiBasla: null,
      KayitTarihiBitis: null,
      itemstarihtip: [
        { text: this.$t("Registration-Date"), value: 0 },
        { text: this.$t("Check-in-Date"), value: 1 },
        { text: this.$t("Check-out-Date"), value: 2 },
        { text: this.$t("Sales-Invoice-Date"), value: 3 },
        { text: this.$t("Commission-Invoice-Date"), value: 4 },
        { text: this.$t("Received-Invoice-Date"), value: 5 }
      ],
      raporTipi: "0",
      itemskomisyon: [
        { text: this.$t("None"), value: false },
        { text: this.$t("Available"), value: true },
        { text: this.$t("All-v2"), value: null }
      ],
      itemsfaturali: [
        { text: this.$t("None"), value: false },
        { text: this.$t("Available"), value: true },
        { text: this.$t("All-v2"), value: null }
      ],
      itemssaticitip: rez.SaticiTip,
      itemsicdis: rez.IcDis,
      itemsopsiyon: rez.Opsiyon,
      searchara: null,
      IptalNedeni: null,
      iptalDialog: false,
      secilenKayit: {},
      sayfayetki: {
        Screen: false,
        Update: false,
        Save: false,
        Delete: false,
        Status: false,
        Message: null,
        islem: 0
      },
      filtrevarmi: false,
      search: "",
      searchsatilanbilet: null,
      searchiadebilet: null,
      searchvoid: null,
      Rapor: {
        PCariDataBase: null,
        PCariSirket: null,
        PSirketNo: null,
        PPNR_No: null,
        PPNR_ParaBirimi: "TL",
        PKayitTarihBas: null,
        PKayitTarihBit: null,
        PDonem1Bas: null,
        PDonem1Bit: null,
        PDonem2Bas: null,
        PDonem2Bit: null,
        PFatTarihBas: null,
        PFatTarihBit: null,
        PKomFatTarihBas: null,
        PKomFatTarihBit: null,
        PCariKod: null,
        PSaticiTip: null,
        PSaticiKod: null,
        PDosyaTip: null,
        PDosya: null,
        PAcente: null,
        PPNRBir: null,
        PCariHesapGrubu: null,
        PCariTip: null,
        PSaticiGrup: null,
        PSaticiIc_Dis: null,
        PTurOp: null,
        PFaturali: null,
        POpsiyon: 0,
        PAnaTip: 0,
        PCariAnaHesap: null,
        PIptalRaporu: false,
        PSaticiOdemesiHesapla: false,
        PRezGrupID: 0,
        PSatisGrubu: 0,
        PSatisGrupTip: 0,
        PMasrafMerkezi: null,
        PAcenteDepartmanID: 0,
        PDekontHaric: false,
        PSatisTip1: true,
        PSatisTip2: true,
        PSatisTip3: true,
        PSatisTip4: true,
        PGelenFatTarihBas: null,
        PGelenFatTarihBit: null,
        PKomisyonFaturali: null,
        PGelenFaturali: false
      },
      TurOperatoru: {
        id: null,
        kod: null,
        isim: null,
        tip: 0
      },
      itemsairlinelist: [],
      hesapgurubu: [],
      masrafmerkezi: [],
      doviztipi: [],
      valid: true,
      totalCount: 0,
      totalService: 0,
      totalAmount: 0,
      StartDate: null,
      EndDate: null,
      date: null,
      menu: false,
      modal: false,
      dateFormatted: "",
      menu2: false,
      dateFormatted2: "",
      modal2: false,
      loading: false,
      items: [],
      load: false,
      load1: true,
      search3: "",
      renk1: "info",
      dialogfiltre: false,
      hesapkodu: [],
      kredikarti: [],
      statecari: [],
      searchcari: "",
      progress: false,
      yok: false,
      itemsdetay: [],
      itemsozet: [],
      butondurum: true,
      snackbar: false,
      y: "top",
      x: "right",
      mode: "",
      timeout: 6000,
      text1: "",
      dictionary: {
        custom: {
          tarihsec: {
            required: () => this.$t("Please-choose-a-date")
          },
          tarihsec1: {
            required: () => this.$t("Please-choose-a-date")
          }
        }
      }
    };
  },
  computed: {
    dateRules() {
      return [(v) => !!v || this.$t("Please-select-a-date")];
    },
    activeHeaders() {
      return this.raporTipi === "0" ? this.detailHeaders : this.summaryHeaders;
    },
    activeItems() {
      return this.raporTipi === "0" ? this.itemsdetay : this.itemsozet;
    },
    activeStorageKey() {
      return this.raporTipi === "0"
        ? "karlilikraporu_detay_report_table"
        : "karlilikraporu_ozet_report_table";
    }
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.prevRoute = from.path;
    });
  },
  mounted() {
    this.detailHeaders = createDetailHeaders(this);
    this.summaryHeaders = createSummaryHeaders(this);

    if (this.$validator && this.$validator.localize) {
      this.$validator.localize("en", this.dictionary);
    }

    this.sayfayetki = helpers.pageScreenAuth(this.$route.name);

    if (this.sayfayetki.Status === true) {
      const credentialsRaw = window.localStorage.getItem("credentials");

      if (credentialsRaw) {
        try {
          const credentials = JSON.parse(credentialsRaw);
          const params = {
            CompanyCode: credentials.SirketKodu
          };

          this.$http
            .post(auth.API_URL + "api/currency/List", params, {
              headers: {
                Authorization: "Bearer " + auth.getAuthHeader()
              }
            })
            .then((response) => {
              this.doviztipi = response.body;
            })
            .catch(() => {
              this.text1 = "Service Unavailable-Döviz";
              this.snackbar = true;
            });
        } catch (error) {
          this.text1 = "Service Unavailable-Döviz";
          this.snackbar = true;
        }
      }
    } else {
      this.$refs.yetkidialog
        .open(this.sayfayetki.Message, this.sayfayetki.islem)
        .then((sonuc) => {
          if (sonuc === true) {
            if (this.prevRoute != null) {
              window.open("#" + this.prevRoute, "_self");
            } else {
              window.open("#/", "_self");
            }
          }
        })
        .catch(() => {});
    }
  },
  methods: {
    pnrIptalDialog(val) {
      this.iptalDialog = true;
      this.IptalNedeni = null;
      this.secilenKayit = val;
    },
    pnrIptal() {
      this.iptalDialog = false;
    },
    HataYonetimi(response, request, baslik) {
      if (response && response.status === 500) {
        this.$refs.hatadialog.open(response, request, baslik);
      } else {
        this.text1 = "Service Unavailable - " + baslik;
        this.snackbar = true;
      }
    },
    git(val) {
      const url = "#/coper/rezervasyon/index/id?islem=get&PNR_No=" + val.PNR_No;
      window.open(url, "_target");
    },
    filtrele() {
      this.dialogfiltre = true;
    },
    filtrekayit() {
      this.filtrevarmi = true;
      this.dialogfiltre = false;
      this.getList();
    },
    filtreiptal() {
      this.filtrevarmi = false;
      this.dialogfiltre = false;
      this.Rapor.PPNR_No = null;
      this.Rapor.PCariKod = null;
      this.Rapor.PSaticiTip = null;
      this.Rapor.PSaticiKod = null;
      this.Rapor.PAcente = null;
      this.Rapor.PCariHesapGrubu = null;
      this.Rapor.PCariTip = null;
      this.Rapor.PSaticiGrup = null;
      this.Rapor.PSaticiIc_Dis = null;
      this.Rapor.PTurOp = null;
      this.Rapor.PFaturali = null;
      this.Rapor.POpsiyon = 0;
      this.Rapor.PAnaTip = 0;
      this.Rapor.PCariAnaHesap = null;
      this.Rapor.PMasrafMerkezi = null;
      this.Rapor.PAcenteDepartmanID = 0;
      this.Rapor.PDekontHaric = false;
      this.Rapor.PSatisTip1 = true;
      this.Rapor.PSatisTip2 = true;
      this.Rapor.PSatisTip3 = true;
      this.Rapor.PSatisTip4 = true;
      this.Rapor.PGelenFatTarihBas = null;
      this.Rapor.PGelenFatTarihBit = null;
      this.Rapor.PKomisyonFaturali = null;
      this.tumsirketler = false;
      this.getList();
    },
    ParametreOlustur() {
      const RaporParam = {};
      const credentials = JSON.parse(window.localStorage.getItem("credentials"));

      RaporParam.PKayitTarihBas = this.Rapor.PKayitTarihBas;
      RaporParam.PKayitTarihBit = this.Rapor.PKayitTarihBit;
      RaporParam.PDonem1Bas = this.Rapor.PDonem1Bas;
      RaporParam.PDonem1Bit = this.Rapor.PDonem1Bit;
      RaporParam.PDonem2Bas = this.Rapor.PDonem2Bas;
      RaporParam.PDonem2Bit = this.Rapor.PDonem2Bit;
      RaporParam.PFatTarihBas = this.Rapor.PFatTarihBas;
      RaporParam.PFatTarihBit = this.Rapor.PFatTarihBit;
      RaporParam.PKomFatTarihBas = this.Rapor.PKomFatTarihBas;
      RaporParam.PKomFatTarihBit = this.Rapor.PKomFatTarihBit;
      RaporParam.PGelenFatTarihBas = this.Rapor.PGelenFatTarihBas;
      RaporParam.PGelenFatTarihBit = this.Rapor.PGelenFatTarihBit;
      RaporParam.PSirketNo = credentials.CoperSirketNo;
      RaporParam.PCariSirket = credentials.SirketKodu;
      RaporParam.PPNR_No = this.Rapor.PPNR_No;
      RaporParam.PPNR_ParaBirimi = this.Rapor.PPNR_ParaBirimi;
      RaporParam.PSaticiTip = this.Rapor.PSaticiTip;

      if (this.Rapor.PCariKod != null) {
        RaporParam.PCariKod = this.Rapor.PCariKod.id;
      } else {
        RaporParam.PCariKod = null;
      }

      if (this.Rapor.PSaticiKod != null) {
        RaporParam.PSaticiKod = this.Rapor.PSaticiKod.kod;
      } else {
        RaporParam.PSaticiKod = null;
      }

      if (this.Rapor.PAcente != null) {
        RaporParam.PAcente = this.Rapor.PAcente.kod;
      } else {
        RaporParam.PAcente = this.Rapor.PAcente;
      }

      RaporParam.PCariHesapGrubu = this.Rapor.PCariHesapGrubu;
      RaporParam.PCariTip = this.Rapor.PCariTip;
      RaporParam.PSaticiGrup = this.Rapor.PSaticiGrup;
      RaporParam.PSaticiIc_Dis = this.Rapor.PSaticiIc_Dis;

      if (this.Rapor.PTurOp != null) {
        RaporParam.PTurOp = this.Rapor.PTurOp.kod;
      } else {
        RaporParam.PTurOp = null;
      }

      RaporParam.PFaturali = this.Rapor.PFaturali;
      RaporParam.POpsiyon = this.Rapor.POpsiyon;
      RaporParam.PAnaTip = this.Rapor.PAnaTip;

      if (this.Rapor.PCariAnaHesap != null) {
        RaporParam.PCariAnaHesap = this.Rapor.PCariAnaHesap.id;
      } else {
        RaporParam.PCariAnaHesap = null;
      }

      if (this.Rapor.PAcenteDepartmanID != null && this.Rapor.PAcenteDepartmanID.kod !== undefined) {
        RaporParam.PAcenteDepartmanID = this.Rapor.PAcenteDepartmanID.kod;
      } else {
        RaporParam.PAcenteDepartmanID = null;
      }

      if (this.Rapor.PMasrafMerkezi != null) {
        RaporParam.PMasrafMerkezi = this.Rapor.PMasrafMerkezi.kod;
      } else {
        RaporParam.PMasrafMerkezi = null;
      }

      RaporParam.PKomisyonFaturali = this.Rapor.PKomisyonFaturali;
      RaporParam.PSatisTip1 = this.Rapor.PSatisTip1;
      RaporParam.PSatisTip2 = this.Rapor.PSatisTip2;
      RaporParam.PSatisTip3 = this.Rapor.PSatisTip3;
      RaporParam.PSatisTip4 = this.Rapor.PSatisTip4;
      RaporParam.PDekontHaric = this.Rapor.PDekontHaric;

      return RaporParam;
    },
    RaporTarihAyarla() {
      if (this.tarihTip === 0) {
        this.Rapor.PKayitTarihBas = this.KayitTarihiBasla;
        this.Rapor.PKayitTarihBit = this.KayitTarihiBitis;
        this.Rapor.PDonem1Bas = null;
        this.Rapor.PDonem1Bit = null;
        this.Rapor.PDonem2Bas = null;
        this.Rapor.PDonem2Bit = null;
        this.Rapor.PFatTarihBas = null;
        this.Rapor.PFatTarihBit = null;
        this.Rapor.PKomFatTarihBas = null;
        this.Rapor.PKomFatTarihBit = null;
        this.Rapor.PGelenFatTarihBas = null;
        this.Rapor.PGelenFatTarihBit = null;
      } else if (this.tarihTip === 1) {
        this.Rapor.PKayitTarihBas = null;
        this.Rapor.PKayitTarihBit = null;
        this.Rapor.PDonem1Bas = this.KayitTarihiBasla;
        this.Rapor.PDonem1Bit = this.KayitTarihiBitis;
        this.Rapor.PDonem2Bas = null;
        this.Rapor.PDonem2Bit = null;
        this.Rapor.PFatTarihBas = null;
        this.Rapor.PFatTarihBit = null;
        this.Rapor.PKomFatTarihBas = null;
        this.Rapor.PKomFatTarihBit = null;
        this.Rapor.PGelenFatTarihBas = null;
        this.Rapor.PGelenFatTarihBit = null;
      } else if (this.tarihTip === 2) {
        this.Rapor.PKayitTarihBas = null;
        this.Rapor.PKayitTarihBit = null;
        this.Rapor.PDonem1Bas = null;
        this.Rapor.PDonem1Bit = null;
        this.Rapor.PDonem2Bas = this.KayitTarihiBasla;
        this.Rapor.PDonem2Bit = this.KayitTarihiBitis;
        this.Rapor.PFatTarihBas = null;
        this.Rapor.PFatTarihBit = null;
        this.Rapor.PKomFatTarihBas = null;
        this.Rapor.PKomFatTarihBit = null;
        this.Rapor.PGelenFatTarihBas = null;
        this.Rapor.PGelenFatTarihBit = null;
      } else if (this.tarihTip === 3) {
        this.Rapor.PKayitTarihBas = null;
        this.Rapor.PKayitTarihBit = null;
        this.Rapor.PDonem1Bas = null;
        this.Rapor.PDonem1Bit = null;
        this.Rapor.PDonem2Bas = null;
        this.Rapor.PDonem2Bit = null;
        this.Rapor.PFatTarihBas = this.KayitTarihiBasla;
        this.Rapor.PFatTarihBit = this.KayitTarihiBitis;
        this.Rapor.PKomFatTarihBas = null;
        this.Rapor.PKomFatTarihBit = null;
        this.Rapor.PGelenFatTarihBas = null;
        this.Rapor.PGelenFatTarihBit = null;
      } else if (this.tarihTip === 4) {
        this.Rapor.PKayitTarihBas = null;
        this.Rapor.PKayitTarihBit = null;
        this.Rapor.PDonem1Bas = null;
        this.Rapor.PDonem1Bit = null;
        this.Rapor.PDonem2Bas = null;
        this.Rapor.PDonem2Bit = null;
        this.Rapor.PFatTarihBas = null;
        this.Rapor.PFatTarihBit = null;
        this.Rapor.PKomFatTarihBas = this.KayitTarihiBasla;
        this.Rapor.PKomFatTarihBit = this.KayitTarihiBitis;
        this.Rapor.PGelenFatTarihBas = null;
        this.Rapor.PGelenFatTarihBit = null;
      } else if (this.tarihTip === 5) {
        this.Rapor.PKayitTarihBas = null;
        this.Rapor.PKayitTarihBit = null;
        this.Rapor.PDonem1Bas = null;
        this.Rapor.PDonem1Bit = null;
        this.Rapor.PDonem2Bas = null;
        this.Rapor.PDonem2Bit = null;
        this.Rapor.PFatTarihBas = null;
        this.Rapor.PFatTarihBit = null;
        this.Rapor.PKomFatTarihBas = null;
        this.Rapor.PKomFatTarihBit = null;
        this.Rapor.PGelenFatTarihBas = this.KayitTarihiBasla;
        this.Rapor.PGelenFatTarihBit = this.KayitTarihiBitis;
      }
    },
    validateDateRange() {
      if (!this.$refs.formgunluksatis.validate()) {
        return false;
      }

      const bastarih = new Date(this.KayitTarihiBasla);
      const bittarih = new Date(this.KayitTarihiBitis);

      if (bastarih <= bittarih) {
        return true;
      }

      this.text1 = this.$t("start-date-cannot-greater-than-end-date");
      this.snackbar = true;
      return false;
    },
    getList() {
      if (!this.validateDateRange()) {
        return;
      }

      this.hasSearched = true;
      this.RaporTarihAyarla();
      this.progress = true;
      this.load1 = false;

      const params = {
        Prm: this.ParametreOlustur(),
        tumSirketler: this.tumsirketler,
        sayfaAdi: this.$route.name
      };

      if (this.raporTipi === "0") {
        tool.http_post(this, "KarlilikRaporu", params)
          .then((response) => {
            if (response.body.Status === true) {
              this.itemsdetay = response.body.data || [];
            } else {
              this.itemsdetay = [];
              this.text1 = response.body.ErrorList[0];
              this.snackbar = true;
            }
          })
          .catch((response) => {
            this.HataYonetimi(response, params, "Karlılık Raporu Getirilemedi");
          })
          .then(() => {
            this.progress = false;
            this.load1 = true;
          });
      } else {
        tool.http_post(this, "KarlilikRaporuOzet", params)
          .then((response) => {
            if (response.body.Status === true) {
              this.itemsozet = response.body.data || [];
            } else {
              this.itemsozet = [];
              this.text1 = response.body.ErrorList[0];
              this.snackbar = true;
            }
          })
          .catch((response) => {
            this.HataYonetimi(response, params, "Karlılık Raporu Getirilemedi");
          })
          .then(() => {
            this.progress = false;
            this.load1 = true;
          });
      }
    },
    getListExcel() {
      if (!this.validateDateRange()) {
        return;
      }

      this.RaporTarihAyarla();
      this.progress = true;
      this.load1 = false;

      const params = {
        Prm: this.ParametreOlustur(),
        tumSirketler: this.tumsirketler,
        sayfaAdi: this.$route.name
      };

      tool.api_post_FileDownload(this, "Coper/ExcelKarlilikRaporu", params)
        .then((response) => {
          const blob = new Blob([response.data], {
            type: "application/xlsx"
          });

          const link = document.createElement("a");
          link.href = window.URL.createObjectURL(blob);
          link.download = "KarlilikRaporu.xlsx";
          link.click();
        })
        .catch(() => {})
        .then(() => {
          this.progress = false;
          this.load1 = true;
        });
    },
    getListOzetExcel() {
      if (!this.validateDateRange()) {
        return;
      }

      this.RaporTarihAyarla();
      this.progress = true;
      this.load1 = false;

      const params = {
        Prm: this.ParametreOlustur(),
        tumSirketler: this.tumsirketler,
        sayfaAdi: this.$route.name
      };

      tool.api_post_FileDownload(this, "Coper/ExcelKarlilikRaporuOzet", params)
        .then((response) => {
          const blob = new Blob([response.data], {
            type: "application/xlsx"
          });

          const link = document.createElement("a");
          link.href = window.URL.createObjectURL(blob);
          link.download = "OzetKarlilikRaporu.xlsx";
          link.click();
        })
        .catch(() => {})
        .then(() => {
          this.progress = false;
          this.load1 = true;
        });
    },
    getListDetayExcel() {
      if (!this.validateDateRange()) {
        return;
      }

      this.RaporTarihAyarla();
      this.progress = true;
      this.load1 = false;

      const params = {
        Prm: this.ParametreOlustur(),
        tumSirketler: this.tumsirketler,
        sayfaAdi: this.$route.name
      };

      tool.api_post_FileDownload(this, "Coper/ExcelKarlilikRaporuDetay", params)
        .then((response) => {
          const blob = new Blob([response.data], {
            type: "application/xlsx"
          });

          const link = document.createElement("a");
          link.href = window.URL.createObjectURL(blob);
          link.download = "DetayKarlilikRaporu.xlsx";
          link.click();
        })
        .catch(() => {})
        .then(() => {
          this.progress = false;
          this.load1 = true;
        });
    }
  }
};
</script>

<style scoped>
.profitability-report-page {
  min-height: 100vh;
  background: #f1f3f5;
}

.page-card {
  min-height: 100vh;
}

.page-toolbar {
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.18);
}

.page-container {
  padding-top: 22px;
}

.filter-card {
  background: #ffffff;
  border-radius: 4px;
}

.filter-actions {
  min-height: 48px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  flex-wrap: wrap;
  gap: 10px;
}

.progress-wrap {
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.filter-chip {
  margin-left: 0;
}

.report-table-host {
  width: 100%;
}

.menu-list {
  min-width: 340px;
}

@media (max-width: 960px) {
  .filter-actions {
    justify-content: flex-start;
  }
}
</style>